import React, { type FC, useMemo } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Destination, SizeType } from 'reactApp/ui/DataListItemCommonComponents/Destination/Destination';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { Date } from 'reactApp/ui/DataListItemRow/components/Date/Date';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import type { IncomingPublicItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';
import { useCompactView } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.new.css';

export const IncomingPublic: FC<IncomingPublicItemProps> = (props) => {
    const { id, storage, name, ext, isSelected, mtime, onCheckboxClick, onDownload, onAuthorContextMenuItem, canShowSharedFileAuthor } =
        props;

    const isCompact = useCompactView();

    const destinationProps = useMemo(() => {
        return {
            size: canShowSharedFileAuthor ? SizeType.l : SizeType.s,
            author: props.author,
        };
    }, [props.author, canShowSharedFileAuthor]);

    return (
        <>
            <TableColumn>
                <Checkbox viewType={EViewMode.list} className={styles.check} onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
            </TableColumn>

            {isCompact ? (
                <TableColumn width="100%" overflow="hidden">
                    <div className={styles.nameWrapper}>
                        <ItemName name={name} ext={ext || ''} id={id} />
                        <span className={styles.responsiveDateWrapper}>
                            <Date date={mtime} className={styles.date} />
                        </span>
                    </div>
                </TableColumn>
            ) : (
                <>
                    <TableColumn width={canShowSharedFileAuthor ? '60%' : '100%'} overflow="hidden">
                        <ItemName name={name} ext={ext || ''} id={id} />
                    </TableColumn>
                    {canShowSharedFileAuthor && (
                        <TableColumn width="40%" overflow="hidden">
                            <Destination
                                {...destinationProps}
                                onAuthorClick={onAuthorContextMenuItem}
                                destination={props.author?.name ?? props.author?.email}
                            />
                        </TableColumn>
                    )}
                    <TableColumn flexBasis={132} flexShrink={0} justifyContent="flex-end">
                        <Date date={mtime} />
                    </TableColumn>
                </>
            )}

            <TableColumn flexBasis={100} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Download onClick={onDownload} ext={ext} id={id} storage={storage} viewType={EViewMode.list} />
            </TableColumn>
        </>
    );
};
